export default "__VITE_ASSET__BmQWC59n__"